<div class="card position-relative">
  <div class="card-body p-5">
    <div class="h1 mb-2">Costs (pro forma)</div>
    <p class="mb-4">Pro forma of the calculated costs. Final amounts may differ.</p>
    @if (proFormaResource.isLoading()) {
      <app-harbour-dues-rotterdam-pro-forma-invoice-skeleton
        [declaration]="inputDeclaration()" />
    } @else if (proFormaResource.hasValue()) {
      @if (isDeclared()) {
        <app-alert summary="Waiting for invoice" class="mb-4">
          We're calculating the invoice(s). This can take a while.
        </app-alert>
      } @else if (shouldReload()) {
        <div class="reload-dialog">
          <p>You’ve made some changes. Click update to re-calculate the costs.</p>
          <button type="button" class="btn btn-outline-primary"
                  (click)="requestProForma()">
            <i class="fa-light fa-arrows-rotate me-2"></i>
            <span>Update</span>
          </button>
        </div>
      }
      <app-harbour-dues-rotterdam-pro-forma-invoice
        [proForma]="proFormaResource.value()"
        [class]="{
          'outdated-pro-forma': shouldReload()
        }" />
    } @else {
      <button type="button" class="btn btn-outline-primary"
              (click)="requestProForma()">
        <i class="fa-light fa-calculator me-2"></i>
        <span>Calculate costs</span>
      </button>
    }
  </div>
</div>
